/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const PluginIcon = /*#__PURE__*/ createSvgIcon(
  'PluginIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M8 17H4.5c-.412 0-.766-.147-1.06-.44A1.445 1.445 0 013 15.5V12a2.105 2.105 0 001.417-.615A1.87 1.87 0 005 10a1.87 1.87 0 00-.583-1.385A2.105 2.105 0 003 8V4.5c0-.412.147-.766.44-1.06.294-.293.648-.44 1.06-.44H8c0-.556.193-1.028.579-1.417A1.919 1.919 0 019.995 1a1.94 1.94 0 011.422.58c.389.387.583.86.583 1.42h3.5c.412 0 .766.147 1.06.44.293.294.44.648.44 1.06V8c.556 0 1.028.193 1.417.579.389.385.583.858.583 1.416a1.94 1.94 0 01-.58 1.422c-.387.389-.86.583-1.42.583v3.5c0 .412-.147.766-.44 1.06-.294.293-.647.44-1.06.44H12a2.11 2.11 0 00-.612-1.417A1.865 1.865 0 0010.002 15c-.543 0-1.005.194-1.387.583A2.105 2.105 0 008 17zm-3.5-1.5h2.333a3.217 3.217 0 011.282-1.469A3.535 3.535 0 0110 13.5c.68 0 1.309.177 1.885.531a3.218 3.218 0 011.282 1.469H15.5v-5H17a.48.48 0 00.35-.15.48.48 0 000-.7.48.48 0 00-.35-.15h-1.5v-5h-5V3a.48.48 0 00-.15-.35.48.48 0 00-.7 0A.48.48 0 009.5 3v1.5h-5v2.333a3.217 3.217 0 011.469 1.282C6.323 8.69 6.5 9.319 6.5 10c0 .697-.177 1.334-.531 1.908A3.1 3.1 0 014.5 13.167V15.5z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default PluginIcon;
